<a href="storybook/{{ name }}">{{ name }}</a>
